import type { CSSProperties } from "react";

/** Fixed preview size for Current / Default banner table columns. */
export const BANNER_TABLE_PREVIEW_WIDTH_PX = 220;
/** YouTube channel banner safe-area aspect ratio (2560×1440). */
export const BANNER_TABLE_PREVIEW_ASPECT_RATIO = 16 / 9;
export const BANNER_TABLE_PREVIEW_HEIGHT_PX = Math.round(
  BANNER_TABLE_PREVIEW_WIDTH_PX / BANNER_TABLE_PREVIEW_ASPECT_RATIO
);

export const bannerTablePreviewBoxStyle: CSSProperties = {
  width: BANNER_TABLE_PREVIEW_WIDTH_PX,
  height: BANNER_TABLE_PREVIEW_HEIGHT_PX,
  maxWidth: "100%",
  aspectRatio: BANNER_TABLE_PREVIEW_ASPECT_RATIO,
};

export const bannerTablePreviewImageStyle: CSSProperties = {
  ...bannerTablePreviewBoxStyle,
  display: "block",
  objectFit: "cover",
  objectPosition: "center",
  borderRadius: 4,
};

/** YouTube banner CDN URLs embed width; use a smaller variant for table previews. */
export function youtubeBannerThumbnailUrl(
  url: string,
  width: number = 320
): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return "";
  }
  if (/=w\d+/.test(trimmed)) {
    return trimmed.replace(/=w\d+/, `=w${width}`);
  }
  return trimmed;
}

export function resolveCurrentBannerDisplayUrl(row: {
  CurrentBannerCachedURL?: string;
  CurrentBannerCachedAt?: string;
  BannerImageURL?: string;
}): string {
  const cached = row.CurrentBannerCachedURL?.trim();
  if (cached) {
    if (!cached.includes("?") && row.CurrentBannerCachedAt?.trim()) {
      return `${cached}?v=${encodeURIComponent(row.CurrentBannerCachedAt.trim())}`;
    }
    return cached;
  }
  return youtubeBannerThumbnailUrl(row.BannerImageURL ?? "");
}
